<div class="fade-in">
	<app-header-button (click)="backClick()" class="back-button">< Back</app-header-button>

	<img src="/assets/img/mira_logo.svg" (click)="nav.navigate(['/'])" />

	<!-- see styles.scss for .account-menu definition -->
	<app-header-button
		nz-popover
		nzPopoverPlacement="bottomRight"
		nzPopoverTrigger="click"
		[nzPopoverContent]="accountTemplate"
		nzPopoverOverlayClassName="account-menu"
		class="account-button"
	>
		<img src="/assets/img/account-icon.svg" class="account-icon" />
		Account
		<span nz-icon nzType="caret-down" nzTheme="outline" class="caret-down-icon"></span>
	</app-header-button>
</div>

<ng-template #accountTemplate>
	<div class="avatar">
		<img class="icon" src="/assets/img/account-icon.svg" />
		<span class="name-and-role">
			<span class="user-name" [nz-tooltip]="userDisplayName">{{ userDisplayName }}</span>
			<span class="user-highest-role">({{ userHighestRole }})</span>
		</span>
	</div>

	@if (isAdmin) {
		<div class="hr"></div>
		<div>
			<div class="menu-title">Admin Account Switcher</div>
			<app-admin-client-selector></app-admin-client-selector>
		</div>
	}

	<div class="menu-links">
		<div class="hr"></div>

		<div class="menu-title">Quick Navigation</div>

		<div
			class="menu-link"
			(click)="nav.navigate(['/', 'my', 'sections'])"
			[ngClass]="isClassesPage ? 'active' : ''"
		>
			<span nz-icon nzType="product" nzTheme="outline"></span>
			<span>Classes</span>
		</div>

		<div class="menu-link" (click)="reportingService.navigateToReports()" [ngClass]="isReportsPage ? 'active' : ''">
			<span nz-icon nzType="area-chart" nzTheme="outline"></span>
			<span>{{ isHighestRoleStudent ? 'Progress' : 'Reports' }}</span>
		</div>

		@if (isAdmin || isClientAdmin || isDistrictAdmin || isSchoolAdmin || isTeacher || isDemo) {
			<div class="menu-link" (click)="nav.navigate(['/', 'my', 'admin'])" [ngClass]="isAdminPage ? 'active' : ''">
				<span nz-icon nzType="user" nzTheme="outline"></span>
				<span>Admin</span>
			</div>
		}

		<div class="hr"></div>

		<div class="menu-link logout">
			<span nz-icon nzType="logout" nzTheme="outline"></span>
			<span (click)="logout()">Logout</span>
		</div>
	</div>
</ng-template>
